import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const TK = 'alfa_admin_token';

export const adminToken = {
  get: () => localStorage.getItem(TK),
  set: (t) => localStorage.setItem(TK, t),
  clear: () => localStorage.removeItem(TK),
};

function authHeaders() {
  const t = adminToken.get();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(email, password) {
  const r = await axios.post(`${API}/api/admin/login`, { email, password });
  adminToken.set(r.data.access_token);
  return r.data;
}

export async function adminMe() {
  const r = await axios.get(`${API}/api/admin/me`, { headers: authHeaders() });
  return r.data;
}

export async function adminListProducts() {
  const r = await axios.get(`${API}/api/admin/products`, { headers: authHeaders() });
  return r.data;
}

export async function adminUpdateProductImage(slug, img) {
  const r = await axios.patch(`${API}/api/admin/products/${slug}/image`, { img }, { headers: authHeaders() });
  return r.data;
}

